import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Box, Flex, Button, Heading, Card } from 'rebass/styled-components'
import FullLayout2 from '../components/FullLayout';
import FormField from '../components/FormField';
import TextInput from '../components/TextInput';
import { gql, useMutation } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import { ICompleteProfileInput, ICompleteProfileOutput } from '../graphql/types/mutations/login';
import withAnalytics from '../lib/withAnalytics';
import { CURRENT_USER, GET_ANALYTICS_ID } from '../graphql/queries';
import LoadingScreen from '../components/LoadingScreen';
import styled from 'styled-components';
import Header from '../components/Header';

const schema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'min. length: 6')
    .trim()
    .required(),
  passwordConfirm: Yup
    .string()
    .trim()
    .oneOf([Yup.ref('password'), undefined], 'Passwords must match'),
});

const COMPLETE_REGISTRATION = gql`
  mutation completeProviderRegistration($password: String!) {
    completeProviderRegistration(password: $password) {
      ok
    }
  }
`;

const Container = styled(Box)`
  max-width: 1024px;
  width: 100%;
  margin: 0 auto !important;
`;

const CardContainer = styled(Flex)`
  max-width: 400px;
`;

interface CompleteProfileProps {
  analytics: any,
}

const CompleteProfile: React.FC<CompleteProfileProps> = ({ analytics }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [mustEnterOtp, setMustEnterOtp] = useState(false);
  const [storedData, setStoredData] = useState<any>(null);

  const [loginMutate, { client }] = useMutation<ICompleteProfileOutput, ICompleteProfileInput>(COMPLETE_REGISTRATION)
  useEffect(() => {
    analytics.page();
    localStorage.removeItem('initialToken');
  }, [])

  const handleSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const { data } = await loginMutate({ variables: { ...values } });
      if (!data?.completeProviderRegistration || !data?.completeProviderRegistration.ok) {

        return
      }

      const aa = await client.query({
        query: GET_ANALYTICS_ID,
        fetchPolicy: 'network-only',
      });

      const pt = await client.query({
        query: CURRENT_USER,
        fetchPolicy: 'network-only',
      });
      if (aa && aa.data && aa.data.getAnalyticsId) {
        analytics.Alias(aa.data.getAnalyticsId);
        try {

          analytics.Identify(aa.data.getAnalyticsId, {
            isProvider: true,
          });
        } catch (error) {
        }
      }

      setStoredData(null);
      navigate('/');
    } catch (error: any) {
      setIsLoading(false);

      if (!error.graphQLErrors) {
        return;
      }

      error.graphQLErrors.forEach((error: any) => {
        if (error.message.toLowerCase() === 'error: otp req') {
          setMustEnterOtp(true);
          return;
        }
        if (error.message.toLowerCase() === 'error: account locked') {
          navigate(
            '/account-locked', {
            state: { email: values.email },
          });
        } else {
          toast.error(error.message, {
            autoClose: 3000
          });
          // toastManager.add(error.message, {
          //   appearance: 'error',
          //   autoDismiss: true,
          // });
        }
      });
    }
  };

  if (isLoading) {
    return <LoadingScreen loading={true} />;
  }
  return (
    <FullLayout2 style={{ overflow: 'auto', zIndex: 10 }}>
      <Container>
        <Flex flex={1} flexDirection="column">
          <Header dark={false} childContainerStyle={{ marginTop: '-16px' }}>

            <Heading sx={{ marginLeft: '153px' }}>Providers</Heading>
          </Header>
        </Flex>
        <Flex flex={1} alignItems="center" justifyContent="center">
          <CardContainer flex={1} px={3}>
            <Card p={4}>
              <Flex flexDirection="column">
                <Box mb={4}>
                  <Heading textAlign="center" mb={3}>
                    Create a password
                  </Heading>
                </Box>
                <Box>
                  <Formik
                    initialValues={{
                      passwordConfirm: '',
                      password: '',
                    }}
                    isInitialValid={() => {
                      try {
                        const aa = schema.validateSync({
                          passwordConfirm: '',
                          password: '',
                        });

                        if (aa.errors && (aa.errors as any).length) {
                          return false;
                        }
                        return true;
                      } catch (err) {
                        return false;
                      }
                    }}
                    validationSchema={schema}
                    onSubmit={(values) => handleSubmit(values)}
                    render={({ touched, errors, isValid }) => {
                      return (
                        <>
                          <Form>

                            <FormField mb={4} error={touched.password && errors.password}>
                              <TextInput placeholder="Password" type="password" name="password" id="input_password" />
                            </FormField>

                            <FormField mb={4} error={touched.passwordConfirm && errors.passwordConfirm}>
                              <TextInput placeholder="Confirm Password" type="password" name="passwordConfirm" id="input_passwordConfirm" />
                            </FormField>
                            <Flex alignItems="center" flexDirection="column">
                              <Button disabled={!isValid || isLoading} variant="primary" width={1 / 2} type="submit" id="btn_login">
                                Continue
                              </Button>
                            </Flex>
                          </Form>
                        </>
                      );
                    }}
                  />
                </Box>
              </Flex>
            </Card>
          </CardContainer>
        </Flex>
      </Container>
    </FullLayout2>
  );
}

export default withAnalytics(CompleteProfile)